// Connector status to show when its charger is offline. The charger can't report
// its connectors, so a stored "available" or "in use" status is stale and would
// mislead (it reads as usable / busy): it shows as "Offline". Any other status —
// Faulted, Unavailable, Reserved, … — is kept as stored. Same rule as cms-api.
export const OFFLINE_CONNECTOR_STATUS = "Offline";

const STALE_WHEN_OFFLINE = new Set([
  "AVAILABLE",
  "CHARGING",
  "IN USE",
  "PREPARING",
  "SUSPENDEDEV",
  "SUSPENDEDEVSE",
  "FINISHING",
]);

export const isStaleWhenOffline = (status) => STALE_WHEN_OFFLINE.has(String(status || "").trim().toUpperCase());

export const connectorStatusWhenOffline = (status) =>
  isStaleWhenOffline(status) ? OFFLINE_CONNECTOR_STATUS : status;
